import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentoPreEditadoFiscal } from 'src/app/_models';
import { CabecalhoRastreio } from 'src/app/_models/CabecalhoRastreio';
import { HistoricoProtocolo } from 'src/app/_models/HistoricoProtocolo';
import { RastrearProtocoloService } from 'src/app/_services/rastrearProtocolo.service';

export interface Filtro {
  idProtocolo: number;
}
@Component({
  selector: 'app-rastrear-protocolo',
  templateUrl: './rastrear-protocolo.component.html',
  styleUrls: ['./rastrear-protocolo.component.css'],
})
export class RastrearProtocoloComponent implements OnInit {
  @ViewChild('historicoPaginator', { static: true }) historicoPaginator: MatPaginator;

  filtros = {} as Filtro;
  loadAcompanhamento = false;
  pesquisaForm: FormGroup;
  lstHistoricoProtocolos = [] as HistoricoProtocolo[];
  displayedColumns = ['dataStatus', 'acao', 'descricao', 'usuario', 'area'];
  dataSource = new MatTableDataSource<HistoricoProtocolo>(this.lstHistoricoProtocolos);
  protocolo = {} as DocumentoPreEditadoFiscal;
  cabecalho = {} as CabecalhoRastreio;
  get f() { return this.pesquisaForm.controls; }
  pedidos = '';
  exibirResultado = false;
  exibirResultadoHistorico = false;

  statusNovoProtocolo = [
    { value: 0, viewValue: 'Indefinido' },
    { value: 1, viewValue: 'Aguardando aprovação' },
    { value: 2, viewValue: 'Aguardando processamento da imagem' },
    { value: 3, viewValue: 'Erro no processamento da Imagem' },
    { value: 4, viewValue: 'Reprovado' },
    { value: 5, viewValue: 'Erro ao enviar para Central de Notas' },
    { value: 6, viewValue: 'Pendende de processamento da fatura' },
    { value: 7, viewValue: 'Aguardando Pagamento' },
    { value: 8, viewValue: 'Concluído/Pago' },
    { value: 9, viewValue: 'Cancelado' },
    { value: 10, viewValue: 'Aguardando lançamento da Fatura' },
    { value: 11, viewValue: 'Erro no lançamento da Fatura' },
    { value: 12, viewValue: 'Aguardando Aprovação Comercial' },
    { value: 99, viewValue: 'Todos os meus protocolos pendentes' },
    { value: 100, viewValue: 'Todos pendentes' }
  ];

  statusProtocolo = [
    { value: 0, viewValue: 'Todos pendentes' },
    { value: 1, viewValue: 'Todos não atribuidos' },
    { value: 2, viewValue: 'Todos os meus protocolos pendentes' },
    { value: 3, viewValue: 'Todos os protocolos' },
    { value: 10, viewValue: 'Protocolo sem documento associado' },
    { value: 12, viewValue: 'Devolvido por não conformidade' },
    { value: 20, viewValue: 'Aguardando documento no UCM' },
    { value: 40, viewValue: 'Concluído' },
    { value: 42, viewValue: 'Problema no envio de documento para o UCM' },
    { value: 43, viewValue: 'Aguardando envio para central de notas' },
    { value: 44, viewValue: 'Cancelado' },
    { value: 45, viewValue: 'Problema no enviar para central de notas' },
    { value: 46, viewValue: 'Erro local ao enviar para o kofax' },
    { value: 47, viewValue: 'Enviado para central de notas sem documento no UCM' },
    { value: 50, viewValue: 'Aguardando lançamento de pedidos' },
    { value: 51, viewValue: 'Aguardando aprovação de pedidos no SLD' },
    { value: 52, viewValue: 'Aguardando cadastro de itens de pedido' },
    { value: 54, viewValue: 'Protocolo criado' },
    { value: 55, viewValue: 'Recusado pelo cockpit' },
    { value: 56, viewValue: 'Aguardando revisão' },
    { value: 57, viewValue: 'Protocolo colocado na fila para pagamento' },
  ];

  sistemas = [
    { value: 1, viewValue: 'MRV Obras' },
    { value: 125, viewValue: 'Protocolo Ged' },
    { value: 153, viewValue: 'MRV Pag' },
  ];

  constructor(
    private RastrearProtocoloService: RastrearProtocoloService,
    private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    this.CarregarValidacoesTela();
    this.exibirResultado = false;
    this.dataSource.paginator = this.historicoPaginator;
  }

  CarregarValidacoesTela() {
    this.pesquisaForm = this.formBuilder.group({
      frmNProtocolo: ['', Validators.required]
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async pesquisar() {
    this.filtros.idProtocolo = this.filtros.idProtocolo || null;
    if (this.filtros.idProtocolo === null) {
      return;
    }

    await this.obterDadosCabecalho(this.filtros.idProtocolo); 
    this.cabecalho.idProtocolo = this.cabecalho.idProtocolo || null

    if (this.cabecalho.idProtocolo !== null){
      await this.visualizarHistorico(this.filtros.idProtocolo);
    } else {
      this.lstHistoricoProtocolos = [] as HistoricoProtocolo[];
      this.dataSource = new MatTableDataSource<HistoricoProtocolo>(this.lstHistoricoProtocolos);
    }

    this.preencherCampoPedido();
  }

  desabilitarPesquisar() {
    this.filtros.idProtocolo = this.filtros.idProtocolo || null;
    if (this.filtros.idProtocolo === null) {
      return true;
    }

    return false;
  }

  exibirStatusNovo() {
    this.cabecalho.statusNovo = this.cabecalho.statusNovo || null;
    return this.cabecalho.statusNovo !== null;
  }

  obterDadosCabecalho(id: number): Promise<boolean> {
    return new Promise(resolve => {
      this.loadAcompanhamento = true;
      this.RastrearProtocoloService.obterCabecalhoRastreioProtocolo(id).subscribe(retorno => {
        if (retorno.success && retorno.data !== null) {
          this.cabecalho = retorno.data as CabecalhoRastreio;
          this.exibirResultado = true;
        } else {
          this.cabecalho = {} as CabecalhoRastreio;
          this.exibirResultado = false;
        }
        this.loadAcompanhamento = false;
        resolve(true);
      }, err => {
        this.exibirResultado = false;
        this.loadAcompanhamento = false;
        resolve(false);
        console.log(`Ocorreu um erro ao obter o protocolo. erro: ${err}`);
      });
    });
  }

  visualizarHistorico(id: number): Promise<boolean> {
    return new Promise(resolve => {
      this.loadAcompanhamento = true;
      this.RastrearProtocoloService.obterHistoricoProtocolo(id).subscribe(
        (sucesso: any) => {
          if (sucesso.success === true && sucesso.data && sucesso.data.length > 0) {
            this.lstHistoricoProtocolos = <HistoricoProtocolo[]>sucesso.data;
            this.exibirResultadoHistorico = true;
          } else {
            this.lstHistoricoProtocolos = [] as HistoricoProtocolo[];
            this.exibirResultadoHistorico = false;
          }
          this.dataSource = new MatTableDataSource<HistoricoProtocolo>(this.lstHistoricoProtocolos);
          this.dataSource.paginator = this.historicoPaginator;
          this.loadAcompanhamento = false;
          resolve(true);
        },
        (error) => {
          this.exibirResultado = false;
          this.loadAcompanhamento = false;
          resolve(false);
          console.log('Error', error);
        });
    });
  }

  preencherCampoPedido() {
    this.cabecalho.pedidos = this.cabecalho.pedidos || [];
    if (this.cabecalho.pedidos.length > 0) {
      const pedidosProtocolo = [];
      this.cabecalho.pedidos.map(element => {
        pedidosProtocolo.push(element.codigoPedido.toString());
      });
      this.pedidos = pedidosProtocolo.join(', ');
    } else {
      this.pedidos = '';
    }
  }
}
